define(["exports", "decorate-component-with-props"], function (_exports, _decorateComponentWithProps) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.generateVariableHighlighterPlugin = void 0;
  _decorateComponentWithProps = _interopRequireDefault(_decorateComponentWithProps);

  var findAllPossibleVariables = function findAllPossibleVariables(content, regex, callback) {
    var text = content.getText();
    var matchArr, start;

    while ((matchArr = regex.exec(text)) !== null) {
      start = matchArr.index;
      callback(start, start + matchArr[0].length);
    }
  };

  var generateVariableHighlighterPlugin = function generateVariableHighlighterPlugin(_ref) {
    var component = _ref.component,
        regex = _ref.regex,
        theme = _ref.theme,
        secondaryRegex = _ref.secondaryRegex,
        _ref$variables = _ref.variables,
        variables = _ref$variables === void 0 ? {} : _ref$variables;
    var hasVariables = Object.keys(variables).length > 0;
    return [{
      strategy: function strategy(contentBlock, callback) {
        return findAllPossibleVariables(contentBlock, regex, callback);
      },
      component: (0, _decorateComponentWithProps.default)(component, {
        variables: variables,
        hasVariables: hasVariables,
        secondaryRegex: secondaryRegex,
        theme: theme
      })
    }];
  };

  _exports.generateVariableHighlighterPlugin = generateVariableHighlighterPlugin;
});